/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITenantIntegrationTemplate } from 'app/shared/model/tenant-integration-template.model';
import { IDataCategory } from 'app/shared/model/data-category.model';
import { ITenantIntegrationChannel } from 'app/shared/model/tenant-integration-channel.model';

export interface ITenantIntegrationTemplateCategory {
  id?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  tenantId?: string | null;
  template?: ITenantIntegrationTemplate | null;
  category?: IDataCategory | null;
  channel?: ITenantIntegrationChannel | null;
}

export const defaultValue: Readonly<ITenantIntegrationTemplateCategory> = {
  active: false,
};
